import "./chatstyles.css";
import AudioIcon from "../../assets/images/icons/audio-icon.png";
import Classdetails from "./Class-details";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import Pausebtn from "../../assets/images/icons/pause.png";
import PlayAgainbtn from "../../assets/images/icons/play-again.png";
import Playbtn from "../../assets/images/icons/play-button.png";
import React, { useRef, useState } from "react";
import StudentTable from "./studenttable";
import UserDetails from "./UserPanel";
import axios from "axios";
import classnames from "classnames";
import { siLK } from "@mui/material/locale";
import { useEffect } from "react";
import { FaEye } from "react-icons/fa";
import { FaInfoCircle } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { getoveralldata } from "../../store/classroom/actions";

import {
  Button,
  Card,
  CardBody,
  CardText,
  Col,
  Container,
  Modal,
  Nav,
  NavItem,
  NavLink,
  Row,
  Spinner,
  TabContent,
  TabPane,
} from 'reactstrap';



const Inbox = () => {
  document.title = 'Linc Quality Hub';
  const [loading, setLoading] = useState(true); // New loading state
  const [studentDeatils, setStudentDeatils] = useState([]);
  const [tabledata, setTableData] = useState([]);
  const [noofFlags, setNoofFlags] = useState(null);
  const [conversationDetails, setConversationDetails] = useState({
    email_sent: { time_and_date: '', subject_and_body: '' },
    email_received: { time_and_date: '', subject_and_body: '' },
    sms_sent: { time_and_date: '', message: '' },
    sms_received: { time_and_date: '', message: '' },
    successful_call: { time_and_date: '', transcription: 0 },
    unsuccessful_call: { time_and_date: '', transcription: 0 },
  });
  // // console.log("data",noofFlags)
  const [cardDataTranscription, setCardTranscription] = useState([]);
  const [loading1, setLoading1] = useState(true);
  const [voicecall, SetVoicecall] = useState();

  const [videoData, setVideoData] = useState(null);
  const [audioData, setAudioData] = useState(null);
  const [currentTime, setCurrentTime] = useState(0);
  const [duration, setDuration] = useState(0);
  const [isPlaying, setIsPlaying] = useState(false);
  const [callQualityKpi, SetcallQualityKpi] = useState();
  const [voiceCallTopics, SetVoicecallTopics] = useState();
  const [callSummary, SetCallSummary] = useState();
  const [teachername, Setteachername] = useState();
  const [redflag, setRedflags] = useState({});
  const user_token = localStorage.getItem('usertoken');
  const videoRef = useRef(null);

  const handlePlayPause = () => {
    if (videoRef.current) {
      if (isPlaying) {
        videoRef.current.pause();
      } else {
        videoRef.current.play();
      }
      setIsPlaying(!isPlaying);
    }
  };

  const handleStop = () => {
    if (videoRef.current) {
      videoRef.current.pause();
      videoRef.current.currentTime = 0;
      setIsPlaying(false);
    }
  };

  const handleProgressClick = (e) => {
    if (videoRef.current) {
      const rect = e.currentTarget.getBoundingClientRect();
      const clickPosition = e.clientX - rect.left;
      const percentage = clickPosition / rect.width;
      videoRef.current.currentTime = percentage * duration;
    }
  };

  useEffect(() => {
    const video = videoRef.current;
    if (video) {
      const updateTime = () => setCurrentTime(video.currentTime);
      const updateDuration = () => setDuration(video.duration);

      video.addEventListener('timeupdate', updateTime);
      video.addEventListener('loadedmetadata', updateDuration);

      return () => {
        video.removeEventListener('timeupdate', updateTime);
        video.removeEventListener('loadedmetadata', updateDuration);
      };
    }
  }, []);
  // console.log("voicecall", voicecall)
  // const [customActiveTab, setcustomActiveTab] = useState("1");
  const navigate = useNavigate(); // Initialize navigate
  const handleNavtoTransactions = () => {
    navigate(-1);
  };
  const location = useLocation();
  const StudentName = location.state?.StudentName;
  const studetails = location.state;
  const Deatilsofteacher = location.state;
  // console.log("inv stu", studetails)
  //tab
  // State to manage the active tab
  const [activeTab, setActiveTab] = useState('transcript');

  // Function to handle tab change
  const toggleTab = (tab) => {
    setActiveTab(tab);
  };
  // modal
  const [modal_center, setmodal_center] = useState(false);
  function tog_center() {
    setmodal_center(!modal_center);
  }

  const [modal_center1, setmodal_center1] = useState(false);
  function tog_center1() {
    setmodal_center1(!modal_center1);
  }

  const [modal_center2, setmodal_center2] = useState(false);
  function tog_center2() {
    setmodal_center2(!modal_center1);
  }

  const [modal_center3, setmodal_center3] = useState(false);
  function tog_center3() {
    setmodal_center3(!modal_center1);
  }

  const [modal_center4, setmodal_center4] = useState(false);
  function tog_center4() {
    setmodal_center4(!modal_center1);
  }

  const [modal_center5, setmodal_center5] = useState(false);
  function tog_center5() {
    setmodal_center5(!modal_center1);
  }

  // tabs

  const toggleCustom = (tab) => {
    if (customActiveTab !== tab) {
      setcustomActiveTab(tab);
    }
  };

  const [customActiveTab, setcustomActiveTab] = useState('1');

  // // console.log("pie",pieOptions)

  // const getColorByScore = (score) => {
  //   if (score >= 80) return '#006400'; // Dark Green
  //   if (score >= 50) return '#90EE90'; // Light Green
  //   return '#e88479'; // Yellow
  // };

  const getColorByScore = (score) => ({
    linearGradient: { x1: 0, y1: 1, x2: 0, y2: 0 },
    stops:
      score < 50
        ? [
          [0, '#FFD6D6'], // light red
          [1, '#FF8A8A'],
        ]
        : score < 80
          ? [
            [0, '#FFF7CC'], // light yellow
            [1, '#FFE066'],
          ]
          : [
            [0, '#D1F7C4'], // light green
            [1, '#90EE90'],
          ],
  });


  const scores = [90, 65, 45, 72, 55, 35]; // Example scores

  const [progressOptions, setProgressOptions] = useState({
    chart: {
      type: 'bar',
    },
    title: {
      text: '',
    },
    xAxis: {
      categories: [
        'Engagement Score',
        'Clarity Score',
        'Responsiveness Score',
        'Call Coverage Score',
        'Student sentiment (positive / neutral / negative)',
        'Overall Call Quality Score',
      ],
    },
    yAxis: {
      title: {
        text: '',
      },
      max: 100,
    },
    series: [
      {
        name: 'Scores',
        color: '#fff',
        pointWidth: 10,
        data: scores.map((score) => ({
          y: score,
          color: getColorByScore(score),
        })),
        dataLabels: {
          enabled: true,
          format: '{point.y}',
          style: {
            fontSize: '12px',
            fontWeight: 'bold',
            color: '#000',
          },
        },
      },
    ],
    credits: {
      enabled: false,
    },
    exporting: {
      enabled: true,
      chartOptions: {
        title: {
          text: 'Call Quality Breakdown',
        },
      },
    },
  });

  const rows = [
    {
      label: 'Progress Check-in',
      value: callSummary?.discussion_points?.progress_check_in,
      title:
        "Did the teacher check-in on the student's progress with the course",
    },
    {
      label: 'Assessment Discussion',
      value: callSummary?.discussion_points?.assessment_discussion,
      title: 'Was an assessment discussed',
    },
    {
      label: 'Draft Discussion',
      value: callSummary?.discussion_points?.draft_discussion,
      title: 'Was an assessment draft discussed shared and discussed',
    },
    {
      label: 'Next Call Setup',
      value: callSummary?.discussion_points?.next_call_setup,
      title: 'Did the teacher setup the next call',
    },
    {
      label: 'Audio / video Issues',
      value: callSummary?.discussion_points?.audio_video_issues,
      title: 'Did the student struggle with voice / call quality ',
    },
    {
      label: 'Recording Compliance',
      value: callSummary?.discussion_points?.recording_compliance,
      title: 'Did the teacher inform the call is being recorded',
    },
  ];

  const [activeTooltip, setActiveTooltip] = useState(null);
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const handleIconClick = (index) => {
    setActiveTooltip((prev) => (prev === index ? null : index));
  };
  // // console.log("pie",progressOptions)

  useEffect(() => {
    const fetchDataTeacherQc = async () => {
      try {
        setLoading(true);

        const payload = {
          university:
            studetails.appliedUniversities?.size > 0
              ? Array.from(studetails.appliedUniversities)
              : null,
          program:
            studetails.appliedPrograms?.size > 0
              ? Array.from(studetails.appliedPrograms)
              : null,
          year:
            studetails.appliedTimelines?.size > 0
              ? Array.from(studetails.appliedTimelines)
              : null,
          term:
            studetails.appliedTerms?.size > 0
              ? Array.from(studetails.appliedTerms)
              : null,
          unit_id:
            studetails.appliedUnit?.size > 0
              ? Array.from(studetails.appliedUnit)
              : null,
          teacher_id:
            studetails.appliedTeacher?.size > 0
              ? parseInt(Array.from(studetails.appliedTeacher))
              : null,
          call_id: studetails.call_id || null,
          mode: 'call_view',
          call_type: 'Video',
        };

        // console.log('Payload:', payload);
        const config = {
          headers: {
            Authorization: `Token ${user_token}`,
          },
        };
        const response = await axios.post(
          process.env.REACT_APP_API_BASE_URL + 'individual_teacher_report/',
          payload,
          config
        );
        // console.log('API Response:', response);
        SetVoicecall(response);
        // Process response data
        const responseteach = response.data;

        Setteachername(responseteach);
        SetVoicecallTopics(responseteach?.topics);
        SetCallSummary(responseteach.summary);
        Setteachername(responseteach);
        setRedflags(responseteach?.red_flags || {})
        // SetVoicecall(responseteach.call_quality)

        setVideoData(responseteach.recording_url);

        //bar chart
        const callQuality =
          responseteach?.call_quality?.call_quality_analysis || {};
        const engagementScore = callQuality?.engagement_score ?? 0;
        const clarityScore = callQuality?.clarity_score ?? 0;
        const responsivenessScore = callQuality?.responsiveness_score ?? 0;
        const callCoverageScore = callQuality?.call_coverage_score ?? 0;
        const studentSentimentScore = callQuality?.student_sentiment_score ?? 0;
        const overallCallQualityScore =
          callQuality?.overall_call_quality_score ?? 0;
        // SetcallQualityKpi(responseteach?.call_quality.kpi)
        SetcallQualityKpi(
          responseteach?.call_quality?.kpi?.replace(/className=/g, 'class='),
        );
        // Update Progress Bar Options Dynamically
        setProgressOptions((prevOptions) => ({
          ...prevOptions,
          series: [
            {
              name: 'Scores',
              color: '#fff',
              pointWidth: 10,
              data: [
                { y: engagementScore, color: getColorByScore(engagementScore) },
                { y: clarityScore, color: getColorByScore(clarityScore) },
                {
                  y: responsivenessScore,
                  color: getColorByScore(responsivenessScore),
                },
                {
                  y: callCoverageScore,
                  color: getColorByScore(callCoverageScore),
                },
                {
                  y: studentSentimentScore,
                  color: getColorByScore(studentSentimentScore),
                },
                {
                  y: overallCallQualityScore,
                  color: getColorByScore(overallCallQualityScore),
                },
              ],
              dataLabels: {
                enabled: true,
                format: '{point.y}',
                style: {
                  fontSize: '12px',
                  fontWeight: 'bold',
                  color: '#000',
                },
              },
            },
          ],
        }));
      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchDataTeacherQc();
  }, [studetails.appliedTeacher, studetails.Studentid]); // Add these

  // If voicecall data is not yet available, render a loading state
  if (!voicecall) {
    return <div>Loading...</div>;
  }
  const formattedAudioDataArray = voicecall.data?.transcription?.map(
    (audio, index) => {
      // Extract unique speaker names from the transcription data
      const speakerNames = [
        ...new Set(voicecall.data?.transcription?.map((line) => line.speaker)),
      ];

      // Map the transcription data to assign speaker classes dynamically
      return voicecall.data?.transcription?.map((line) => ({
        speakerClass:
          line.speaker === speakerNames[0] ? 'speaker-a' : 'speaker-b', // Assign class based on the first speaker name
        text: line.text, // The actual transcription text
        speaker: line.speaker,
        start: Math.round(parseFloat(line.start) * 100) / 100, // Rounded to 2 decimal places
        end: Math.round(parseFloat(line.end) * 100) / 100, // Rounded to 2 decimal places
      }));
    },
  );

  return (
    <React.Fragment>
      <div className="page-content px-0">
        <Container fluid={true}>
          <div className="d-flex gap-2 align-items-center mb-2">
            <Button
              onClick={handleNavtoTransactions}
              className="mb-0 back-arrow-btn"
            >
              <i className="fas fa-arrow-left"></i>
            </Button>

            <h3 className="bold mb-0 ml-2">
              Individual Student Voice Analytics Report-{' '}
              {StudentName || 'Student Name'}
            </h3>
          </div>
          <div className="ind-teacher-report-tab">
            <Nav className="mb-0" tabs>
              <NavItem>
                <NavLink
                  className={activeTab === 'transcript' ? 'active' : ''}
                  active={activeTab === 'transcript'}
                  onClick={() => toggleTab('transcript')}
                  style={{ cursor: 'pointer', marginRight: '3px' }}
                >
                  Call Transcript
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={activeTab === 'summary' ? 'active' : ''}
                  active={activeTab === 'summary'}
                  onClick={() => toggleTab('summary')}
                  style={{ cursor: 'pointer', marginRight: '3px' }}
                >
                  Call Summary
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={activeTab === 'topics' ? 'active' : ''}
                  active={activeTab === 'topics'}
                  onClick={() => toggleTab('topics')}
                  style={{ cursor: 'pointer', marginRight: '3px' }}
                >
                  Topics Discussed
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={activeTab === 'all' ? 'active' : ''}
                  active={activeTab === 'all'}
                  onClick={() => toggleTab('all')}
                  style={{ cursor: 'pointer', marginRight: '2px' }}
                >
                  Call Analysis
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={activeTab === 'redflages' ? 'active' : ''}
                  active={activeTab === 'redflages'}
                  onClick={() => toggleTab('redflages')}
                  style={{ cursor: 'pointer', marginRight: '3px' }}
                >
                  Red Flags
                </NavLink>
              </NavItem>
              {/* <NavItem>
                <NavLink
                  className={activeTab === "kpi" ? "active" : ""}
                  active={activeTab === "kpi"}
                  onClick={() => toggleTab("kpi")}
                  style={{ cursor: "pointer", marginRight: "3px" }}
                >
                  KPI
                </NavLink>
              </NavItem> */}
            </Nav>
            {activeTab === 'all' && (
              <div>
                {/* <Card className="mb-2">
                  {callData ? (

                    <CardBody>
                      {loading ? ( 
                        <div
                          className="d-flex justify-content-center align-items-center"
                          style={{ height: "200px" }}
                        >
                          <Spinner style={{ width: "3rem", height: "3rem" }} />
                        </div>
                      ) : (
                        <Row className="g-2">
                          <Col xxl={2} xl={3} lg={4} sm={6}>
                            <Card
                              className="minty-gradient border-green mb-0 h-100 ex-link"

                              style={{ cursor: 'pointer' }}
                            >
                              <CardBody>
                                <div>
                                  <div className="mb-2">
                                    <p className="f-14 semibold">Call Quality Score</p>
                                  </div>
                                  <div className="flex-grow-1 flex-wrap gap-2 d-flex justify-content-between align-items-center overflow-hidden">
                                    <h4 className="bold">{voicecall.data.call_quality.quality_score || '0'}</h4>
                                  </div>
                                </div>
                              </CardBody>
                            </Card>
                          </Col>
                          <Col xxl={2} xl={3} lg={4} sm={6}>
                            <Card
                              className="sky-gradient border-sky mb-0 h-100 ex-link"

                              style={{ cursor: 'pointer' }}
                            >
                              <CardBody>
                                <div>
                                  <div className="mb-2">
                                    <p className="f-14 semibold">Student Sentiment</p>
                                  </div>
                                  <div className="flex-grow-1 flex-wrap gap-2 d-flex justify-content-between align-items-center overflow-hidden">
                                    <h4 className="bold">{voicecall.data.call_quality.student_sentiment || '0'}</h4>
                                  </div>
                                </div>
                              </CardBody>
                            </Card>
                          </Col>
                          <Col xxl={2} xl={3} lg={4} sm={6}>
                            <Card
                              className="peachy-gradient border-red mb-0 h-100 ex-link"

                              style={{ cursor: 'pointer' }}
                            >
                              <CardBody>
                                <div>
                                  <div className="mb-2">
                                    <p className="f-14 semibold">Red Flags</p>
                                  </div>
                                  <div className="flex-grow-1 flex-wrap gap-2 d-flex justify-content-between align-items-center overflow-hidden">
                                    <h4 className="bold">{voicecall.data.call_quality.redflags || '0'}</h4>
                                  </div>
                                </div>
                              </CardBody>
                            </Card>
                          </Col> */}
                {/* <Col xxl={2} xl={3} lg={4} sm={6}>
                            <Card
                              className="lavender-gradient border-lavender mb-0 h-100 ex-link"

                              style={{ cursor: 'pointer' }}
                            >
                              <CardBody>
                                <div>
                                  <div className="mb-2">
                                    <p className="f-14 semibold">Total Call Duration (Mins)</p>
                                  </div>
                                  <div className="flex-grow-1 flex-wrap gap-2 d-flex justify-content-between align-items-center overflow-hidden">
                                    <h4 className="bold">{studentDeatils?.Total_call_duration || '0'}</h4>
                                  </div>
                                </div>
                              </CardBody>
                            </Card>
                          </Col> */}
                {/* </Row>
                      )}
                    </CardBody>


                  ) : (
                    <div className="text-center p-4">

                    </div>
                  )}
                </Card> */}

                <Row className="g-2">
                  <Col md={12} className="mb-2">
                    <Card className="mb-0 h-100">
                      <CardBody>
                        <h5 className="f-16 d-flex  bold mb-3 ">
                          Call Quality Rubric{' '}
                        </h5>
                        <HighchartsReact
                          highcharts={Highcharts}
                          options={progressOptions}
                        />
                        <div
                          className="mt-2"
                          dangerouslySetInnerHTML={{
                            __html: callQualityKpi || '<p>No KPI.</p>',
                          }}
                        />
                      </CardBody>
                    </Card>
                  </Col>
                </Row>
              </div>
            )}

            {activeTab === 'summary' && (
              <div>
                <Card
                  className="border box-shadow-none mb-0"
                  style={{ borderTopLeftRadius: '0' }}
                >
                  <CardBody className="border" style={{ minHeight: '500px' }}>
                    <div className="va-info-wrapper">
                      <h4 className="bold">Call Summary:</h4>
                      <div className="mt-2">
                        <div
                          dangerouslySetInnerHTML={{
                            __html: callSummary?.call_summary,
                          }}
                        />
                      </div>
                      <h4 className="bold mt-2">Discussion Points</h4>
                      {/* <div className="mt-2">
                        <table className="bordered-table">
                          <tbody>
                            {rows.map((row, index) => (
                              <tr key={index}>
                                <td className="pointer  align-items-center gap-2" style={{ position: "relative" }}>
                                  {row.label}
                                  <span
                                    onMouseEnter={() => setHoveredIndex(index)}
                                    onMouseLeave={() => setHoveredIndex(null)}
                                    style={{ position: "relative", display: "inline-block", cursor: "pointer" }}
                                  >
                                    <FaInfoCircle />
                                    {hoveredIndex === index && (
                                      <span className="tooltip-box">{row.title}</span>
                                    )}
                                  </span>
                                </td>
                                <td>{row.value}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div> */}
                      <div className="mt-2">
                        <table className="bordered-table">
                          <tbody>
                            {rows.map((row, index) => (
                              <tr key={index}>
                                <td>
                                  <span
                                    className="position-relative d-inline-block"
                                    onMouseEnter={() => setHoveredIndex(index)}
                                    onMouseLeave={() => setHoveredIndex(null)}
                                    style={{ cursor: 'pointer' }}
                                  >
                                    {row.label}
                                    {hoveredIndex === index && (
                                      <span className="tooltip-box">
                                        {row.title}
                                      </span>
                                    )}
                                  </span>
                                </td>
                                <td>{row.value}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                      <br></br>
                      <h4 className="bold mt-2">
                        {' '}
                        Knowledge Gaps Identified / Common Doubts Raised by
                        student{' '}
                      </h4>
                      <div className="mt-2">
                        <div
                          dangerouslySetInnerHTML={{
                            __html: callSummary?.knowledge_gaps_identified,
                          }}
                        />
                      </div>
                    </div>
                  </CardBody>
                </Card>
              </div>
            )}

            {activeTab === 'transcript' && (
              <Card
                className="border box-shadow-none mb-0"
                style={{ borderTopLeftRadius: '0' }}
              >
                <CardBody
                  style={{
                    minHeight: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                  }}
                >
                  <div
                    className="va-info-wrapper"
                    style={{ flexGrow: 1, overflow: 'auto' }}
                  >
                    <div
                      className="audio chat-container"
                      style={{
                        height: '100%',
                        display: 'flex',
                        flexDirection: 'column',
                      }}
                    >
                      <div className="d-flex flex-column flex-grow-1 overflow-auto">
                        <div className="">
                          <div>
                            <p className="bold">Student Name: {StudentName}</p>
                            <br></br>
                            <p className="bold">
                              Teacher Name: {teachername?.teacher_name}{' '}
                            </p>
                          </div>
                          <br></br>
                          {videoData ? (
                            <div className="video-chat-container justify-content-between mt-0 ">
                              <div className="floating-video-player w-100 mt-0">
                                <video
                                  src={videoData}
                                  controlsList="nodownload"
                                  controls
                                  style={{ borderRadius: '10px' }}
                                />
                              </div>
                            </div>
                          ) :
                            <p>Session recording not available </p>

                          }
                        </div>
                        <br></br>
                        {formattedAudioDataArray &&
                          formattedAudioDataArray[0] &&
                          formattedAudioDataArray[0].map((line, index) => (
                            <div
                              key={index}
                              className={`chat-bubble ${line.speakerClass}`}
                            >
                              <strong>{line.speaker}</strong>
                              <br />
                              {line.text}
                              <br />
                              <span>
                                {line.start}s - {line.end}s
                              </span>
                            </div>
                          ))}
                      </div>
                    </div>
                  </div>
                </CardBody>
              </Card>
            )}
            {activeTab === 'topics' && (
              <div>
                <Card
                  className="border box-shadow-none mb-0"
                  style={{ borderTopLeftRadius: '0' }}
                >
                  <CardBody
                    className="border"
                    style={{ minHeight: '500px', height: '100vh' }}
                  >
                    <div className="mt-2">
                      {voiceCallTopics &&
                        Object.entries(voiceCallTopics).map(
                          ([topicName, qas], index) => (
                            <div key={index} className="mb-3">
                              <h5>{topicName}</h5>
                              {qas.map((qa, qaIndex) => (
                                <div key={qaIndex} className="mb-2">
                                  <p>
                                    <strong>Q:</strong> {qa.question}
                                  </p>
                                  <p>
                                    <strong>A:</strong> {qa.answer}
                                  </p>

                                  {/* Show A Mark if is_assessment_related is true */}
                                  {qa.is_assessment_related && (
                                    <p className="text-success">
                                      <strong>A :</strong> ✓ Assessment Related
                                    </p>
                                  )}
                                </div>
                              ))}
                            </div>
                          ),
                        )}
                    </div>
                  </CardBody>
                </Card>
              </div>
            )}
            {activeTab === 'redflages' && (
              <div>
                <Card
                  className="border box-shadow-none mb-0"
                  style={{ borderTopLeftRadius: '0' }}
                >
                  <CardBody className="border" style={{ minHeight: '500px' }}>
                    <div className="va-info-wrapper">
                      <div className="mt-2">
                        <h5 className="f-16 d-flex  bold mb-3">Red Flags</h5>
                        {/* FLAGS SECTION */}
                        {redflag?.flags?.length > 0 ? (
                          <>
                            <ul>
                              {redflag.flags.map((flag, index) => (
                                <li key={index}>{flag}</li>
                              ))}
                            </ul>
                          </>
                        ) : (
                          <p className="f-14 d-flex mb-3">No Flags Identified</p>
                        )}

                        {/* REASON SECTION */}
                        <h5 className="f-16 d-flex  bold mb-3">Reason</h5>
                        <div
                          className="mt-2"
                          dangerouslySetInnerHTML={{
                            __html:
                              redflag?.reason ||
                              '<p>No Reasons Available.</p>',
                          }}
                        />

                      </div>
                    </div>
                  </CardBody>
                </Card>
              </div>
            )}
            {activeTab === 'kpi' && (
              <div>
                <Card
                  className="border box-shadow-none mb-0"
                  style={{ borderTopLeftRadius: '0' }}
                >
                  <CardBody className="border" style={{ minHeight: '500px' }}>
                    <div className="va-info-wrapper">
                      <h4 className="bold">KPI :</h4>

                      <div className="mt-2">
                        <div
                          dangerouslySetInnerHTML={{
                            __html: voicecall.data.kpi,
                          }}
                        />
                      </div>
                    </div>
                  </CardBody>
                </Card>
              </div>
            )}
          </div>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default Inbox;
